import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "proxyForm"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "代人叫车", -1);
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "banner"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "h1"
}, "您想为谁叫车？", -1);
const _hoisted_6 = {
  class: "description"
};
const _hoisted_7 = {
  class: "card passenger-form"
};
const _hoisted_8 = {
  class: "passenger-input passenger-mobile"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "separate"
}, null, -1);
const _hoisted_10 = {
  class: "passenger-input passenger-name"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "hint"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("ul", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("li", null, "如未成年人乘车，建议由家长或监护人陪同；"), /*#__PURE__*/_createElementVNode("li", null, "请提醒乘车人在行程中注意安全，文明乘车。")], -1);
const _hoisted_14 = {
  class: "button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createVNode(_component_van_icon, {
    name: "success"
  }), _createTextVNode(" 司机直接联系乘车人 ")]), _createElementVNode("div", null, [_createVNode(_component_van_icon, {
    name: "success"
  }), _createTextVNode(" 可实时查看乘车行程 ")])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_van_icon, {
    name: "phone-o"
  }), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dataPassengerMobile = $event),
    placeholder: "输入乘车人手机号",
    maxlength: "11"
  }, null, 512), [[_vModelText, $data.dataPassengerMobile]])]), _hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_icon, {
    name: "contact"
  }), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.dataPassengerName = $event),
    placeholder: "输入乘车人姓名（选填）"
  }, null, 512), [[_vModelText, $data.dataPassengerName]])])]), _createElementVNode("div", {
    class: "card passenger-contact-passenger",
    onClick: _cache[3] || (_cache[3] = $event => $data.dataPriorityContactPassenger = !$data.dataPriorityContactPassenger)
  }, [_createTextVNode(" 司机优先联系乘车人 "), _createElementVNode("img", {
    class: "checkbox",
    src: $data.dataPriorityContactPassenger ? require('@/assets/icon/checked.png') : require('@/assets/icon/check.png'),
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $data.dataPriorityContactPassenger = !$data.dataPriorityContactPassenger, ["stop"]))
  }, null, 8, _hoisted_11)]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_icon, {
    name: "warning",
    color: "#1989fa"
  }), _hoisted_13]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_van_button, {
    color: "#ff8c00",
    block: "",
    plain: "",
    onClick: $options.selfButtonClick
  }, {
    default: _withCtx(() => [_createTextVNode(" 为自己叫车 ")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_van_button, {
    color: "#ff9500",
    block: "",
    disabled: !($data.dataPassengerMobile.length === 11),
    onClick: $options.enterButtonClick
  }, {
    default: _withCtx(() => [_createTextVNode(" 为 TA 叫车 ")]),
    _: 1
  }, 8, ["disabled", "onClick"])])])]);
}